export function useExternalAmounts(text) {
    const { $formatter } = useNuxtApp();

    if (!text) return text;

    return text.replace(/<span\s+class=["']amount["']>(.*?)<\/span>/g, (_, value) => {
        const price = Number(value.replace(/[^\d.-]+/g, ''));
        if (isNaN(price)) return _;

        const formatted = $formatter.price(price, null, 0);
        return `<span class="amount">${formatted}</span>`;
    });
}
